export default __webpack_public_path__ + "static/media/gmail.4230c4d5.svg";